var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5879 2.19052C19.357 1.33362 18.6814 0.658764 17.8247 0.42845C16.2599 5.04696e-08 9.99953 0 9.99953 0C9.99953 0 3.74006 -2.52348e-08 2.17433 0.411516C1.33482 0.641829 0.642943 1.33446 0.412033 2.19052C0 3.75529 0 7 0 7C0 7 0 10.2608 0.412033 11.8095C0.642943 12.6655 1.31765 13.3412 2.17519 13.5715C3.75637 14 9.99953 14 9.99953 14C9.99953 14 16.2599 14 17.8247 13.5885C18.6814 13.3582 19.357 12.6825 19.5879 11.8256C19.9999 10.2608 19.9999 7.01609 19.9999 7.01609C19.9999 7.01609 20.0162 3.75529 19.5879 2.19052ZM8.00632 9.99746V4.00254L13.2125 7L8.00632 9.99746Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.dd811e3e.svg";
export { ForwardRef as ReactComponent };